export const GET_STATISTICS_BEST_PLAYERS = "GET_STATISTICS_BEST_PLAYERS";
export const CLEAR_FILTERS_BEST_PLAYERS = "CLEAR_FILTERS_BEST_PLAYERS";